import "./ProjectHeader.scss";

const ProjectHeader = ({ projectName, tabTitle = "", isOverview = false }) => {
    return (
        <div className="content-header mb-2">
            <h2 className="mb-0">
                <span className="project-heading">{projectName}</span>
                {!isOverview && (
                    <>
                        <span className="project-heading-separator">|</span>
                        <span className="project-heading-subtitle">{tabTitle}</span>
                    </>
                )}
            </h2>
        </div>
    );
};

export default ProjectHeader;
